import { createContext } from 'react';

export type DashboardContextType = { dashboardId: string };

export const DashboardContext = createContext<DashboardContextType>({
  dashboardId: '',
});
